/**
 * Returns props to unmask specific component content for Sentry Replay.
 * With global replay sampling enabled, no manual start/stop is required.
 *
 * @returns {{ 'data-sentry-unmask': boolean }} Props object that can be spread onto components
 */
const useSentryReplayUnmask = () => {
  return { 'data-sentry-unmask': true };
};

export default useSentryReplayUnmask;
